<script>
import { authService } from '@services/safehaven/AuthService'
import layout from '@src/mixins/layout.vue'
import store from '@state/store'

export default {
  page: {
    title: 'Access Code',
    meta: [{ name: 'description', content: 'The Access Code page.' }],
  },
  components: {},
  mixins: [layout],
  data() {
    return {
      valid: false,
      receivedError: false,
      accessCode: '',
      accessCodeRules: [
        (v) => !!v || 'Access code is required',
        (v) => !this.codeError || 'Access code is invalid',
      ],
    }
  },
  computed: {
    codeError() {
      if (this.receivedError) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    store.dispatch('calender/setRecordDetails', { path: null })
  },
  created() {
    store.dispatch('calender/setRecordDetails', { path: null })
  },
  methods: {
    validate() {
      this.$refs.form.validate()
      if (this.valid) {
        this.validateCode()
      }
    },
    async validateCode() {
      try {
        const orgDetails = JSON.parse(
          localStorage.getItem('organisationDetails')
        )
        const validCode = await authService.validate({
          org_id: orgDetails.org,
          signup_code: this.accessCode,
        })
        if (validCode && validCode.data) {
          validCode.data.signup_code = this.accessCode
          this.$router.push({
            name: 'safehaven-signup',
            params: {
              clientId: this.$route.params.clientId,
              userDetails: validCode.data,
            },
          })
        }
      } catch (error) {
        this.receivedError = true
        this.$refs.form.validate()
        console.warn(error)
      }
    },
    removeErrors() {
      this.receivedError = false
      this.$refs.form.validate()
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-row no-gutters justify="center">
      <v-form ref="form" v-model="valid" @submit.prevent="validate">
        <v-row no-gutters justify="center" class="mb-2">
          <v-col cols="12" class="mb-6" :class="$style.title">
            Enter your access code
          </v-col>
          <v-col>
            <v-text-field
              v-model="accessCode"
              hide-details="auto"
              dense
              :class="$style.textField"
              :rules="accessCodeRules"
              outlined
              @input="removeErrors"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters justify="center">
          <v-col cols="12" md="8" align="center">
            <v-fab-transition>
              <v-btn type="submit" class="mt-2 primary-btn w-m-90-btn" bottom>
                Enter Code
              </v-btn>
            </v-fab-transition>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          class="mt-4"
          justify="center"
          :class="$style.representativeText"
        >
          <v-col align="center">
            You must have an access code to create an account. Please check your
            email for an invitation with your access code.
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-4" justify="center">
          <v-col align="center" class="hrRouterLinkText">
            <router-link
              style="

                font-size: 14px !important;
                font-weight: 700;
                text-decoration: none !important;
              "
              class="#0476D9--text"
              :to="{ name: 'safehaven-code-retrieval' }"
              >Resend Access Code</router-link
            >
          </v-col>
        </v-row>
      </v-form>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.mandatory {
  color: #da1414;
}
.text,
.representativeText {
  align-items: center;
  margin: 0.5rem auto;
  font-size: 14px !important;
  color: #2c3a4b;
}
.title {
  font-size: 18px;
  font-weight: 700;
}
.textField {
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.75px;
}
.hrRouterLinkText a {
  font-size: 14px !important;
}
</style>
